import type { ReactNode } from 'react';

// Iconos de línea monocromos: usan currentColor → se tiñen con el color del link
// (gris apagado normal, verde acento cuando la pestaña está activa).
function Svg({ size = 30, children }: { size?: number; children: ReactNode }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {children}
    </svg>
  );
}

type P = { size?: number };

// Hoy → casa
export const IconHoy = (p: P) => (
  <Svg {...p}>
    <path d="M3 11l9-8 9 8" />
    <path d="M5 9.5V20h14V9.5" />
  </Svg>
);

// Partidos → calendario
export const IconPartidos = (p: P) => (
  <Svg {...p}>
    <rect x="3" y="4" width="18" height="17" rx="2" />
    <path d="M3 9h18M8 2v4M16 2v4" />
  </Svg>
);

// Resumen → medalla
export const IconResumen = (p: P) => (
  <Svg {...p}>
    <path d="M7 3l4 7M17 3l-4 7" />
    <circle cx="12" cy="15.5" r="6" />
    <circle cx="12" cy="15.5" r="2.2" />
  </Svg>
);

// Zonas → grilla
export const IconZonas = (p: P) => (
  <Svg {...p}>
    <rect x="3" y="3" width="7" height="7" rx="1" />
    <rect x="14" y="3" width="7" height="7" rx="1" />
    <rect x="3" y="14" width="7" height="7" rx="1" />
    <rect x="14" y="14" width="7" height="7" rx="1" />
  </Svg>
);

// Llave → cuadro/bracket
export const IconLlave = (p: P) => (
  <Svg {...p}>
    <path d="M4 5h4M4 11h4M8 5v6M8 8h4" />
    <path d="M4 13h4M4 19h4M8 13v6M8 16h4" />
    <path d="M12 8v8M12 12h4" />
    <path d="M16 12h4" />
  </Svg>
);

// Histórico → reloj con flecha (history)
export const IconHistorico = (p: P) => (
  <Svg {...p}>
    <path d="M3 4v5h5" />
    <path d="M3.5 13a9 9 0 1 0 2.4-8L3 9" />
    <path d="M12 8v4.5l3.5 2" />
  </Svg>
);

// Uso (admin) → gráfico de barras
export const IconUso = (p: P) => (
  <Svg {...p}>
    <path d="M3 21h18" />
    <path d="M6 21V11M12 21V4M18 21v-6" />
  </Svg>
);
